import React, { useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { theme } from 'assets/theme'
import { QueryClient } from '@tanstack/react-query'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import '@ionic/react/css/core.css'
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/typography.css'

import { setupIonicReact } from '@ionic/react'
import { ScreenOrientation } from '@capacitor/screen-orientation'
import { Capacitor } from '@capacitor/core'
import { NewRouter } from 'Router/newRouter'

import { Authenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'
import { Amplify } from 'aws-amplify'
import awsExports from 'config/aws-export'
import awsExportsProd from 'config/aws-export-prod'

const isProd = process.env.NODE_ENV === 'production'

Amplify.configure(isProd ? awsExportsProd : awsExports)

setupIonicReact()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      gcTime: 1000 * 60 * 60 * 1 // 24 hours
    }
  }
})

const persister = createSyncStoragePersister({
  storage: window.localStorage
})

// const dehydrateOptions: DehydrateOptions = {
//   shouldDehydrateQuery: (query) => {
//     const queryIsReadyForPersistance = query.state.status === 'success'
//     if (queryIsReadyForPersistance) {
//       const { queryKey } = query
//       const excludeFromPersisting = queryKey.includes('userDashboard')
//       return !excludeFromPersisting
//     }
//     return queryIsReadyForPersistance
//   }
// }

function App() {
  const isMobilePlatform =
    Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android'
  useEffect(() => {
    if (isMobilePlatform) {
      ScreenOrientation.lock({
        orientation: 'portrait'
      })
    }
  }, [])
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <PersistQueryClientProvider
          client={queryClient}
          persistOptions={{
            persister
            // dehydrateOptions
          }}
        >
          {/* <AppRouter /> */}
          <Authenticator.Provider>
            <NewRouter />
          </Authenticator.Provider>
          <ReactQueryDevtools initialIsOpen={false} />
        </PersistQueryClientProvider>
        {!isMobilePlatform && (
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        )}
      </ErrorBoundary>
    </ThemeProvider>
  )
}

export default App
